<p-confirmDialog></p-confirmDialog>
<p-toast></p-toast>
<div class="rounded-xl">
    <div class="flex  sm:flex-row justify-between items-start sm:items-center mb-4 sm:mb-6 gap-3 sm:gap-0">
        <h2 class="text-lg sm:text-2xl font-bold text-gray-900">Portfolio Management</h2>
        <button (click)="openAddDialog()"
            class=" sm:w-auto cursor-pointer bg-gradient-to-r from-amber-500 to-amber-600 text-white px-4 sm:px-6 py-2 rounded-lg font-semibold hover:from-amber-600 hover:to-amber-700 transition-all shadow-lg flex items-center justify-center">
            <i-lucide name="plus" class="h-4 w-4 sm:h-5 sm:w-5 mr-2"></i-lucide>
            <span class="text-sm sm:text-base">Add Portfolio</span>
        </button>
    </div>
 <!-- Loading State -->
    <div *ngIf="isLoading" class="loading-container">
        <div class="loading-spinner"></div>
        <p>Loading portfolios...</p>
    </div>
      <div *ngIf="!isLoading" class="transactions-table-container overflow-x-auto">
    <p-table [value]="portfolios" [paginator]="false" 
        class="p-datatable-sm w-full rounded-lg overflow-hidden" [style]="{ 'max-height': '600px', 'min-width': '800px' }">
        <ng-template pTemplate="header">
            <tr class="bg-gray-50">
                <th class="px-2 sm:px-4 py-2 sm:py-3 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider" style="min-width: 120px;">Name</th>
                <th class="px-2 sm:px-4 py-2 sm:py-3 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider" style="min-width: 80px;">Risk</th>
                <th style="min-width: 120px;"
                    class="px-2 sm:px-4 py-2 sm:py-3 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider">Actual ROI
                    (%)</th>
                    <th style="min-width: 120px;"
                    class="px-2 sm:px-4 py-2 sm:py-3 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider">ROI Potential
                    (%)</th>
                <th class="px-2 sm:px-4 py-2 sm:py-3 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider" style="min-width: 80px;">Tenure
                    (M)</th>
                <th class="px-2 sm:px-4 py-2 sm:py-3 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider" style="min-width: 100px;">Ticket
                    Price</th>
                <th class="px-2 sm:px-4 py-2 sm:py-3 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider" style="min-width: 80px;">Total</th>
                <th class="px-2 sm:px-4 py-2 sm:py-3 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider" style="min-width: 80px;">Available</th>
                <th class="px-2 sm:px-4 py-2 sm:py-3 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider" style="min-width: 80px;">Reserved</th>
                <th class="px-2 sm:px-4 py-2 sm:py-3 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider" style="min-width: 60px;">Sold</th>
                <th class="px-2 sm:px-4 py-2 sm:py-3 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider" style="min-width: 80px;">Status</th>
                <th class="px-2 sm:px-4 py-2 sm:py-3 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider" style="min-width: 100px;">Created</th>
                <th class="px-2 sm:px-4 py-2 sm:py-3 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider" style="min-width: 120px;">Actions</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-portfolio>
            <tr class="hover:bg-gray-50 transition-colors">
                <td class="px-2 sm:px-4 py-2 sm:py-3 whitespace-nowrap font-medium text-gray-900 text-xs sm:text-sm">{{ portfolio.name }}</td>
                <td class="px-2 sm:px-4 py-2 sm:py-3 whitespace-nowrap">
                    <span
                        [ngClass]="portfolio.riskLevel === 'High' ? 'bg-red-100 text-red-800' : portfolio.riskLevel === 'Medium' ? 'bg-yellow-100 text-yellow-800' : 'bg-green-100 text-green-800'"
                        class="px-1 sm:px-2 py-0.5 sm:py-1 rounded-full text-xs font-semibold">
                        {{ portfolio.riskLevel }}
                    </span>
                </td>
                 <td class="px-2 sm:px-4 py-2 sm:py-3 whitespace-nowrap text-green-700 font-semibold text-xs sm:text-sm">{{ portfolio?.actualRoiPercentage || '-' }}</td>
                <td class="px-2 sm:px-4 py-2 sm:py-3 whitespace-nowrap text-green-700 font-semibold text-xs sm:text-sm">{{ portfolio.roiPotential }}</td>
                <td class="px-2 sm:px-4 py-2 sm:py-3 whitespace-nowrap text-xs sm:text-sm">{{ portfolio.tenure }}</td>
                <td class="px-2 sm:px-4 py-2 sm:py-3 whitespace-nowrap text-amber-700 font-semibold text-xs sm:text-sm">{{ portfolio.ticketPrice | number }}</td>
                <td class="px-2 sm:px-4 py-2 sm:py-3 whitespace-nowrap text-xs sm:text-sm">{{ portfolio.totalTickets }}</td>
                <td class="px-2 sm:px-4 py-2 sm:py-3 whitespace-nowrap text-xs sm:text-sm">{{ portfolio.availableTickets }}</td>
                <td class="px-2 sm:px-4 py-2 sm:py-3 whitespace-nowrap text-xs sm:text-sm">{{ portfolio?.reservedTickets }}</td>

                <td class="px-2 sm:px-4 py-2 sm:py-3 whitespace-nowrap text-xs sm:text-sm">{{ portfolio.soldTickets }}</td>
                <td class="px-2 sm:px-4 py-2 sm:py-3 whitespace-nowrap">
                    <span [ngClass]="portfolio.isActive ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'"
                        class="px-1 sm:px-2 py-0.5 sm:py-1 rounded-full text-xs font-semibold">
                        {{ portfolio.status }}
                    </span>
                </td>
                <td class="px-2 sm:px-4 py-2 sm:py-3 whitespace-nowrap text-gray-600 text-xs">{{ formatDate(portfolio.createdAt) }}</td>
                <td class="px-2 sm:px-4 py-2 sm:py-3 whitespace-nowrap">
                    <div class="flex gap-1 sm:gap-2 items-center">
                        <!-- Update the styling for buttons when disabled -->
                        <button (click)="onEditPortfolio(portfolio)" 
                            class="p-1 sm:p-2 rounded-full bg-amber-100 hover:bg-amber-200 text-amber-700 hover:text-amber-900 transition disabled:bg-gray-100 disabled:text-gray-400"
                            pTooltip="Edit">
                            <i-lucide name="square-pen" class="h-3 w-3 sm:h-4 sm:w-4"></i-lucide>
                        </button>
                        <button (click)="onDeletePortfolio(portfolio)" [disabled]="portfolio.isPublished == true"
                            class="p-1 sm:p-2 rounded-full bg-red-100 hover:bg-red-200 text-red-700 hover:text-red-900 transition disabled:bg-gray-100 disabled:text-gray-400"

                            pTooltip="Delete">
                            <i-lucide name="trash-2" class="h-3 w-3 sm:h-4 sm:w-4"></i-lucide>
                        </button>
                        <button (click)="openPublishDialog(portfolio)" [disabled]="portfolio.isPublished == true"
                            class="p-1 sm:p-2 rounded-full bg-green-100 hover:bg-green-200 text-green-700 hover:text-green-900 transition disabled:bg-gray-100 disabled:text-gray-400"
                            pTooltip="Publish">
                            <i-lucide name="cloud-upload" class="h-3 w-3 sm:h-4 sm:w-4"></i-lucide>
                        </button>
                    </div>
                </td>
            </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
            <tr>
                <td colspan="12" style="text-align: center;" class="text-center py-8 text-gray-400">No portfolios found.
                </td>
            </tr>
        </ng-template>
    </p-table>

    <p-paginator [rows]="pagination.itemsPerPage" [totalRecords]="pagination.totalItems"
        [first]="(pagination.currentPage - 1) * pagination.itemsPerPage" [rowsPerPageOptions]="[10, 20, 50]"
        (onPageChange)="onPageChange($event)" class="mt-6"></p-paginator>
</div>
    <p-dialog header="Add Portfolio" [(visible)]="showAddDialog" [modal]="true" [closable]="true"
        [dismissableMask]="true" [style]="{width: '95vw', 'max-width': '600px'}" [responsive]="true" (onHide)="closeAddDialog()">
        <form [formGroup]="addPortfolioForm" (ngSubmit)="submitAddPortfolio()" class="space-y-3 sm:space-y-4">
            <div class="grid grid-cols-1 lg:grid-cols-2 gap-3 sm:gap-4">
                <div>
                    <label class="block text-xs sm:text-sm font-medium text-gray-700 mb-1">Name <span
                            class="text-red-500">*</span></label>
                    <input type="text" formControlName="name"
                        class="w-full px-3 sm:px-4 py-1.5 sm:py-2 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-amber-500 focus:border-transparent placeholder-gray-400 text-gray-900"
                        placeholder="Portfolio Name" />
                </div>
                <div>
                    <label class="block text-xs sm:text-sm font-medium text-gray-700 mb-1">Risk Level <span
                            class="text-red-500">*</span></label>
                    <p-dropdown [options]="riskLevels" formControlName="riskLevel" optionLabel="label"
                        optionValue="value" [style]="{'width': '100%'}" class="w-full text-sm"></p-dropdown>
                </div>
            </div>
            <div>
                <label class="block text-xs sm:text-sm font-medium text-gray-700 mb-1">Description </label>
                <textarea formControlName="description" rows="2"
                    class="w-full px-3 sm:px-4 py-1.5 sm:py-2 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-amber-500 focus:border-transparent placeholder-gray-400 text-gray-900"
                    placeholder="Portfolio Description"></textarea>
            </div>
            <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-4">
                <div>
                    <label class="block text-xs sm:text-sm font-medium text-gray-700 mb-1">ROI Potential (%) <span
                            class="text-red-500">*</span></label>
                    <input type="tel" formControlName="roiPotential"
                        class="w-full px-3 sm:px-4 py-1.5 sm:py-2 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-amber-500 focus:border-transparent placeholder-gray-400 text-gray-900"
                        placeholder="15" />
                </div>
                <div>
                    <label class="block text-xs sm:text-sm font-medium text-gray-700 mb-1">Tenure (Months) <span
                            class="text-red-500">*</span></label>
                    <input type="tel" formControlName="tenure"
                        class="w-full px-3 sm:px-4 py-1.5 sm:py-2 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-amber-500 focus:border-transparent placeholder-gray-400 text-gray-900"
                        placeholder="5" />
                </div>
                <div>
                    <label class="block text-xs sm:text-sm font-medium text-gray-700 mb-1">Ticket Price <span
                            class="text-red-500">*</span></label>
                    <input type="tel" formControlName="ticketPrice"
                        class="w-full px-3 sm:px-4 py-1.5 sm:py-2 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-amber-500 focus:border-transparent placeholder-gray-400 text-gray-900"
                        placeholder="50000" />
                </div>
                <div>
                    <label class="block text-xs sm:text-sm font-medium text-gray-700 mb-1">Total Tickets <span
                            class="text-red-500">*</span></label>
                    <input type="tel" formControlName="totalTickets"
                        class="w-full px-3 sm:px-4 py-1.5 sm:py-2 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-amber-500 focus:border-transparent placeholder-gray-400 text-gray-900"
                        placeholder="100" />
                </div>
            </div>
            <div>
                <label class="block text-xs sm:text-sm font-medium text-gray-700 mb-1">Investment Focus <span
                        class="text-red-500">*</span></label>
                <input type="text" formControlName="investmentFocus"
                    class="w-full px-3 sm:px-4 py-1.5 sm:py-2 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-amber-500 focus:border-transparent placeholder-gray-400 text-gray-900"
                    placeholder="e.g. Real Estate, UAE, Commercial" />
                <p class="text-xs text-gray-500 mt-1">Enter focus areas separated by commas.</p>
            </div>
            <div class="grid grid-cols-1 lg:grid-cols-2 gap-3 sm:gap-4">
                <div>
                    <label class="block text-xs sm:text-sm font-medium text-gray-700 mb-1">Investment Start Date <span
                            class="text-red-500">*</span></label>
                    <p-datepicker formControlName="investmentStartDate" dateFormat="yy-mm-dd" inputId="startDate"
                        [showIcon]="true" [showButtonBar]="true" placeholder="YYYY-MM-DD" styleClass="w-full"
                        [style]="{'width': '100%'}"
                        inputStyleClass="w-full px-3 sm:px-4 py-1.5 sm:py-2 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-amber-500 focus:border-transparent"></p-datepicker>
                </div>
                <div>
                    <label class="block text-xs sm:text-sm font-medium text-gray-700 mb-1">Investment Closure Date <span
                            class="text-red-500">*</span></label>
                    <p-datepicker formControlName="investmentClosureDate" dateFormat="yy-mm-dd" inputId="closureDate"
                        [showIcon]="true" [showButtonBar]="true" placeholder="YYYY-MM-DD" styleClass="w-full"
                        [style]="{'width': '100%'}"
                        inputStyleClass="w-full px-3 sm:px-4 py-1.5 sm:py-2 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-amber-500 focus:border-transparent"></p-datepicker>
                </div>
            </div>
            <div>
                <label class="block text-xs sm:text-sm font-medium text-gray-700 mb-1">Admin Note</label>
                <textarea formControlName="adminNote" rows="2"
                    class="w-full px-3 sm:px-4 py-1.5 sm:py-2 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-amber-500 focus:border-transparent placeholder-gray-400 text-gray-900"
                    placeholder="Internal note for admins (optional)"></textarea>
            </div>
            <div class="flex items-center gap-2 mt-2">
                <p-checkbox formControlName="isActive" id="isActive" binary="true"></p-checkbox>
                <label for="isActive" class="text-xs sm:text-sm font-medium text-gray-700 select-none">Active</label>
            </div>
            <div class="mt-3 sm:mt-4">
                <label class="block text-xs sm:text-sm font-medium text-gray-700 mb-1">Images <span
                        class="text-red-500">*</span></label>
                <p-fileUpload #fileUpload mode="basic" [multiple]="true" accept="image/png,image/jpeg,image/jpg" [maxFileSize]="2000000"
                    chooseLabel="Upload Images" class="w-full" [auto]="true" (onSelect)="onImagesSelected($event)"
                    [showCancelButton]="false" styleClass="p-button-outlined p-button w-full"
                    chooseIcon="i-lucide-upload">
                    <ng-template pTemplate="chooseicon">
                        <i-lucide name="upload" class="h-5 w-5"></i-lucide>
                    </ng-template>
                </p-fileUpload>
                <p class="text-xs text-amber-600 mt-1">Note: Maximum size: 2MB per image. Only PNG, JPG, and JPEG formats are allowed.</p>
                <div class="flex flex-wrap gap-2 mt-2">
                    <div *ngFor="let img of imagePreviews; let i = index" class="relative group">
                        <img [src]="img | imageUrl" alt="Preview"
                            class="w-12 h-12 sm:w-16 sm:h-16 object-cover rounded border border-gray-300 shadow" />
                        <button type="button" (click)="removeImage(i)"
                            class="cursor-pointer absolute -top-1 -right-1 sm:-top-2 sm:-right-2 bg-red-500 text-white rounded-full p-0.5 sm:p-1 shadow-lg opacity-0 group-hover:opacity-100 transition-opacity">
                            <i-lucide name="x" class="h-2 w-2 sm:h-3 sm:w-3"></i-lucide>
                        </button>
                    </div>
                </div>
            </div>
            <div class="flex flex-col sm:flex-row justify-end mt-4 sm:mt-6 gap-2 sm:gap-0">
                <button type="button" (click)="closeAddDialog()"
                    class="w-full sm:w-auto cursor-pointer bg-gray-200 text-gray-700 px-4 sm:px-6 py-2 rounded-lg font-semibold sm:mr-2 hover:bg-gray-300 text-sm">Cancel</button>
                <button type="submit" [disabled]="addLoading || addPortfolioForm.invalid"
                    class="w-full sm:w-auto cursor-pointer bg-gradient-to-r from-amber-500 to-amber-600 text-white px-4 sm:px-6 py-2 rounded-lg font-semibold hover:from-amber-600 hover:to-amber-700 transition-all shadow-lg disabled:opacity-50 disabled:cursor-not-allowed text-sm">
                    {{ addLoading ? (editingPortfolioId ? 'Saving...' : 'Adding...') : (editingPortfolioId ? 'Save
                    Changes' : 'Add Portfolio') }}
                </button>
            </div>
        </form>
    </p-dialog>

    <!-- Publish Portfolio Dialog -->
    <p-dialog header="Publish Portfolio" [(visible)]="showPublishDialog" [modal]="true" [closable]="true"
        [dismissableMask]="true" [style]="{width: '95vw', 'max-width': '400px'}" [responsive]="true" (onHide)="closePublishDialog()">
        <form [formGroup]="publishForm" (ngSubmit)="submitPublishPortfolio()" class="space-y-3 sm:space-y-4">
            <div>
                <label class="block text-xs sm:text-sm font-medium text-gray-700 mb-1">Actual ROI Percentage <span
                        class="text-red-500">*</span></label>
                <input type="tel" formControlName="actualRoiPercentage" min="0.01" step="0.01"
                    class="w-full px-3 sm:px-4 py-1.5 sm:py-2 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-amber-500 focus:border-transparent placeholder-gray-400 text-gray-900"
                    placeholder="e.g. 12.5" />
                <div *ngIf="publishForm.get('actualRoiPercentage')?.invalid && publishForm.get('actualRoiPercentage')?.touched"
                    class="text-xs text-red-500 mt-1">
                    Actual ROI Percentage is required and must be greater than 0.
                </div>
            </div>
            <div class="flex flex-col sm:flex-row justify-end mt-4 sm:mt-6 gap-2 sm:gap-0">
                <button type="button" (click)="closePublishDialog()"
                    class="w-full sm:w-auto cursor-pointer bg-gray-200 text-gray-700 px-4 sm:px-6 py-2 rounded-lg font-semibold sm:mr-2 hover:bg-gray-300 text-sm">Cancel</button>
                <button type="submit" [disabled]="publishLoading || publishForm.invalid"
                    class="w-full sm:w-auto cursor-pointer bg-gradient-to-r from-amber-500 to-amber-600 text-white px-4 sm:px-6 py-2 rounded-lg font-semibold hover:from-amber-600 hover:to-amber-700 transition-all shadow-lg disabled:opacity-50 disabled:cursor-not-allowed text-sm">
                    {{ publishLoading ? 'Publishing...' : 'Publish' }}
                </button>
            </div>
        </form>
    </p-dialog>

</div>